let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4X6d3")).then(() => parcelRequire('6cyCu'));